import React from "react";
import Moment from "react-moment";
import moment from 'moment'
//import Loader from "react-loader-spinner";
const History = ({ subscriptions, loading }) => {
	const user = JSON.parse(localStorage.getItem("user"));

	return (
		<div className="container--default mt-4 p-3 p-md-4">
			<h2 className="container__title pt-1 pt-md-2">History</h2>
			<div className="table__container pt-2 pt-md-4">
				{/*loading && (
					<div className="d-flex flex-column justify-content-center pr-md-4">
						<div
							className="input__field mt-3 w-100 mt-md-4"
							style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
						>
							<Loader type="TailSpin" color="#3326ae" height={50} width={50} />
							<p className="input__label" style={{ marginLeft: "15px" }}>
								Veuillez patienter
							</p>
						</div>
					</div>
				)*/}
				<div className="table__row py-1 d-md-flex align-items-center justify-content-between">
					<p className="fz--16 fw--500">Trial period</p>
					<p className="fz--14 pt-1 pt-md-0 flex-shrink-0">
						From <Moment format="DD MMM, YYYY">{user.trialStart}</Moment> to  <Moment format="DD MMM, YYYY">{moment(user.trialStart).add(7,'days')}</Moment>
					</p>
				</div>

				{subscriptions !== null && (
					<>
						{subscriptions.map((item, index) => (
							<div className="table__row py-1 d-md-flex align-items-center justify-content-between" key={index}>
								<p className="fz--16 fw--500">
									{item.isActive ? `Subscription : ${item.transaction.amount} $` : `Subscription canceled`}
								</p>
									<p className="fz--14 pt-1 pt-md-0 flex-shrink-0">
										From <Moment format="DD MMM, YYYY">{item.trialStart ? item.trialStart : item.start}</Moment> to <Moment format="DD MMM, YYYY">{item.end}</Moment>
									</p>
							</div>
						))}
					</>
				)}
				{user.subscriptionDeleted && (
					<div className="table__row py-1 d-md-flex align-items-center justify-content-between">
						<p className="fz--16 fw--500">Subscription canceled</p>
						<p className="fz--14 pt-1 pt-md-0 flex-shrink-0">
							<Moment format="DD MMM, YYYY">{user.subscriptionDeletedAt}</Moment>
						</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default History;
